module.exports = __webpack_public_path__ + "static/media/消防电伴热1.88d68d76.jpg";